<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import { getColorVariant } from "../../helpers/badgeLookupTable";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  name: "DocumentosCharts",

  props: {
    data: Object, // should contain pendientes, presentados, legalizados, retirados
  },

  data() {
    return {
      series: [],
      chartOptions: {
        labels: ["Pendiente", "Presentado", "Legalizado", "Retirado"],
        chart: {
          width: 100,
          type: "donut",
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
        },
        fill: {
          colors: [
            getColorVariant("Pendiente"),
            getColorVariant("Presentado"),
            getColorVariant("Legalizado"),
            getColorVariant("Retirado"),
          ],
        },
        responsive: [
          {
            breakpoint: 430,
            options: {
              chart: {
                width: 100,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.updateSeries(); // initialize
  },

  watch: {
    data: {
      handler() {
        this.updateSeries();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    updateSeries() {
      this.series = [
        this.data?.pendientes ?? 0,
        this.data?.presentados ?? 0,
        this.data?.legalizados ?? 0,
        this.data?.retirados ?? 0,
      ];
    },
  },
};
</script>

<template>
  <div id="charts" class="mt-2 mx-auto">
    <slot name="ver"></slot>
    <apexchart
      class="mx-auto"
      v-if="series && series.length > 0"
      type="donut"
      height="250"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<style scoped>
.apexcharts-canvas {
  margin: auto !important;
}
</style>
